import { render, staticRenderFns } from "./optionInput.vue?vue&type=template&id=f5a6def8"
import script from "./optionInput.vue?vue&type=script&lang=js"
export * from "./optionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports